import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { PopoverController } from '@ionic/angular';
import { DetailWebsitePage } from '../page-public/detail-website/detail-website.page';
import { ModalController } from '@ionic/angular';
import { DetailEksisPage } from '../page-public/detail-eksis/detail-eksis.page';
import{ApiService} from '../services/api.service';
@Component({
  selector: 'app-tab1',
  templateUrl: 'tab-home.page.html',
  styleUrls: ['tab-home.page.scss']
})
export class TabHomePage {
  keyApp:any;
  constructor(private popover:PopoverController, private modalCtrl:ModalController, private navCtrl:NavController, private api:ApiService)
  {
      this.keyApp=localStorage.getItem('keyApp');
     this.getDataSekolah();
     this.getDataAgenda();
     this.getDataPrestasi();
     this.getLatestNews();
     this.getSlides();
  }
  dataSekolah:any={};
  getDataSekolah()
  {
    var keyApp=localStorage.getItem('keyApp');
    this.api.data('user/school?keyApp='+keyApp,'get','').subscribe(data=>{
      this.dataSekolah=data;
    })
  }
  dataAgenda:any=[];
  getDataAgenda()
  {
    var keyApp=localStorage.getItem('keyApp');
    this.api.data('agenda?page=1&key_app='+keyApp,'get','').subscribe(data=>{
      this.parseDataAgenda(data);
    })
  }
  parseDataAgenda(data)
  {
    for(var i=0; i<data.length; i++)
    {
      this.dataAgenda.push(data[i]);
    }
  }
  dataPrestasi:any=[];
  getDataPrestasi()
  {
    var keyApp=localStorage.getItem('keyApp');
    this.api.data('prestasi?page=1&key_app='+keyApp,'get','').subscribe(data=>{
      this.parseDataPrestasi(data);
    })
  }
  parseDataPrestasi(data)
  {
    for(var i=0; i<data.length; i++)
    {
      this.dataPrestasi.push(data[i]);
    }
  }

  //slides
  slides:any=[];
  getSlides()
  {
      this.api.data('slider?key_app='+this.keyApp,'get','').subscribe(data=>{
          this.slides=data;
      })
  }

  //latest News
  latestNews:any=[];
  getLatestNews()
  {
      this.api.data('eksis?key_app='+this.keyApp+'&page=1','get','').subscribe(data=>{
          this.latestNews=data;
      })
  }
	sliderOpts = {
    freeMode: false,
    slidesPerView: 2,
    spaceBetween: 10,
    centeredSlides: false,
  };

  sliderAdds = {
    freeMode: false,
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
	    autoplay: {
	    delay: 5000,
	  },
  };
  sliderPrestasi = {
    freeMode: false,
    slidesPerView: 2,
    spaceBetween: 10,
    centeredSlides: false,
    loop: false,
	    autoplay: {
	    delay: 5000,
	  },
  };

	user = {
    profileImage: 'assets/imgs/logo.png',
  };

  
  async showMenu(ev: any) {
    const popover = await this.popover.create({
        component: MenuHome,
        event: ev,
        animated: true,
        showBackdrop: false
    });
    return await popover.present();
  }

  isTransparent:boolean=true;
  onScroll($event) {    
    if ($event && $event.detail && $event.detail.scrollTop) { 
      if($event.detail.scrollTop >= 225)    
      this.isTransparent = false;
      else this.isTransparent = true;
    }
  }

  async modalWeb(data) {
    const modal = await this.modalCtrl.create({
      component: DetailEksisPage,
      componentProps: {
        posting:data
      }
    });
    return await modal.present();
  }

  async modalEksis() {
    const modal = await this.modalCtrl.create({
      component: DetailEksisPage,
    });
    return await modal.present();
  }

 

}


@Component({
  selector: 'menu-home',
  templateUrl: 'menu-home.html'
})
export class MenuHome {
   constructor(public popover:PopoverController)
    {

    }
}